import { FC } from 'react';

import { Header } from '@rbilabs/universal-components';
import { usePaymentContext } from 'features/payment';
import { StyleProp, ViewStyle } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import Currency from 'components/currency';
import { t } from 'state/intl/translations';

import { BalanceText, TextContainer, TransferBalanceContent } from './styled';

interface ITransferBalance {
  cardBalance: number;
  giftCardNumber: string;
  // TODO: Remove customStyle prop after checkout v2 experiment cleanup
  // This prop is a temporary workaround for layout inconsistencies between
  // checkout v1 and v2 implementations. Once the experiment is removed and
  // we have a unified layout system, this custom styling should be replaced
  // with proper responsive design patterns.
  // Also, we need to match the figma design for both the treatment and control
  // https://rbictg.atlassian.net/browse/BKPE-22791
  customStyle?: StyleProp<ViewStyle>;
}

export const TransferBalanceContainer: FC<React.PropsWithChildren<ITransferBalance>> = ({
  cardBalance,
  giftCardNumber,
  customStyle,
}) => {
  const { getPrepaidPaymentMethod } = usePaymentContext();

  const currentBalance = getPrepaidPaymentMethod()?.prepaid?.currentBalance || 0;
  const transferCardBalance = cardBalance;
  const cardNumber = giftCardNumber;
  const totalAmount = currentBalance + transferCardBalance;
  const formatCardNumber = cardNumber?.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ');

  const isTransferCardBalanceValid = transferCardBalance && transferCardBalance > 0;

  return (
    isTransferCardBalanceValid && (
      <TransferBalanceContent style={customStyle}>
        <Header variant="headerTwo">
          <Typography fontSize="xl">{t('transfer')} </Typography>
          <Currency textProps={{ fontSize: 'xl' }} amount={transferCardBalance} />?
        </Header>
        <TextContainer>
          <BalanceText>
            {t('transferGiftCardYourCurrentGift')}
            <Currency textProps={{ fontSize: 'md' }} amount={currentBalance} isBold />
          </BalanceText>
        </TextContainer>
        <TextContainer>
          <BalanceText>
            {t('transferGiftCardTheCard')}
            <BalanceText bold>{formatCardNumber}</BalanceText>
            <BalanceText>
              {t('transferGiftCardHasABalance')}
              <Currency textProps={{ fontSize: 'md' }} amount={transferCardBalance} isBold />.
            </BalanceText>
          </BalanceText>
        </TextContainer>
        <TextContainer>
          <BalanceText>
            {t('transferGiftCardWouldYouLikeTo')}
            <Currency textProps={{ fontSize: 'md' }} amount={transferCardBalance} isBold />
            {t('transferGiftCardToYourCardFor')}
            <Currency textProps={{ fontSize: 'md' }} amount={totalAmount} isBold />
            {t('transferGiftCardNewBalanceQuestion')}
          </BalanceText>
        </TextContainer>
      </TransferBalanceContent>
    )
  );
};
